import { onBeforeMount, ref, computed, getCurrentInstance, onMounted, toValue } from 'vue';

export function useToast() {
    const instance = ref();
    const errorToast = computed(() => instance.value?.ctx?.errorToast);
    const successToast = computed(() => instance.value?.ctx?.successToast);
    const warningToast = computed(() => instance.value?.ctx?.warningToast);
    const infoToast = computed(() => instance.value?.ctx?.infoToast);
    onMounted(() => {
        instance.value = getCurrentInstance();
    });
    return {
        errorToast: errorToast,
        successToast: successToast,
        warningToast: warningToast,
        infoToast: infoToast,
    };
}
